import React, { useState, useRef } from 'react';
import { ReactComponent as TeamSubIcon } from 'images/teamSubIcon.svg';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { SelectList } from 'components/ui/SelectList/SelectList';
import { Button } from '@trackman/web-shared-components';
import { Control, EditLineupMenuWrapper } from './EditLineupMenuStyles';

interface IProps {
  homeTeamName: string;
  awayTeamName: string;
  onOptionSelected: (isHomeTeam: boolean) => void;
}

export const EditLineupMenu: React.FC<IProps> = (props) => {
  const { homeTeamName, awayTeamName, onOptionSelected } = props;
  const ref = useRef<any>();
  const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false);
  useOnClickOutside(ref, () => setIsMenuVisible(false), 'click');

  const handleOnClickHome = () => {
    onOptionSelected(true);
  };

  const handleOnClickAway = () => {
    onOptionSelected(false);
  };

  const handleOnClickMenu = () => {
    setIsMenuVisible(!isMenuVisible);
  };
  return (
    <EditLineupMenuWrapper ref={ref} onClick={handleOnClickMenu}>
      <Button label='Team subs' intent='secondary' onClick={() => {}} width={123} startIcon={<TeamSubIcon />} />
      <SelectList visible={isMenuVisible}>
        <Control onClick={handleOnClickHome}>{homeTeamName}</Control>
        <Control onClick={handleOnClickAway}>{awayTeamName}</Control>
      </SelectList>
    </EditLineupMenuWrapper>
  );
};
